/** Loom — “What Makes Us Different?” (price & plan video card) */
export const LOOM_WHAT_MAKES_US_DIFFERENT_SHARE =
  'https://www.loom.com/share/36c7f96d2c684443b0f0a95c2f9bb436?sid=cb13891b-b6d3-4d6d-8ea7-e480e27332c7';

/** Same video, embed URL for iframe `src` (Loom share links are not valid HTML5 video sources). */
export const LOOM_WHAT_MAKES_US_DIFFERENT_EMBED =
  'https://www.loom.com/embed/36c7f96d2c684443b0f0a95c2f9bb436';
